import styled from "@emotion/styled";
import theme from "@theme";
const Button = styled.button`
  width: 92%;
  width: 100%;
  height: 35px;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #ea7507;
  border-image-slice: 1;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  @media (min-width: 768px) {
    width: 92%;
    height: 35px;
  }
  @media (min-width: 1400px) {
    width: 310px;
    height: 35px;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: 35px;
  }
`;

const img = styled.img`
  width: 18px;
  height: 18px;
  gap: 0px;
  opacity: 0px;
`;
const pdiv = styled.div`
  font-family: Roboto;
  font-size: 60px;
  font-weight: 700;
  line-height: 96.5px;
  letter-spacing: -0.04em;
  text-align: center;
  font-family: Roboto;
  font-size: 64px;
  font-weight: 700;
  line-height: 96.5px;
  letter-spacing: -0.04em;
  text-align: center;
  width: 903px;
  height: 180px;
  top: 719px;
  left: 28px;
  gap: 0px;
  opacity: 0px;
`;
const MainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  position: relative;
  margin-bottom: 10px;
  @media (min-width: 1400px) {
  width:  310px; 
  height: 35px;
`;
const ChildDivTwo = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  height: 2rem;
  background-color: ${theme.colors.white};
  padding: 0 10px;
  font-size: 12px;
  font-weight: bold;
  color: #5b5b5b;
  position: relative;
  z-index: 1;
`;
const ChildDivOneThree = styled.div`
  border-top: 1px dashed ${theme.colors.bordertask};
  flex: 1;
`;

const SC = {
  Button,
  img,
  pdiv,
  Button,
  img,
  ChildDivOneThree,
  ChildDivTwo,
  MainDiv,
};

export default SC;
